export default "__VITE_ASSET__DqCbGpu___"